var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0_9511_20884)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_9511_20884",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9511_20884",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_9511_20884",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAABxklEQVR4nO3dvU5VQRhG4ZVgS8IFWAmGxITCEi6CcJ1oJFRC402ol2Hkx8aCfIZkLCFQzH5n71lP8jacgjOzaCjO2SBJkiRJkrQab4Cd9JuY0UfgG/AA1GD7BXwCDtiofeB+gIuuF4R4xwZdDnC59cJ9ZYP+DHCx9YodszG1sl2xMbXCnbAhtcJ9B3bZiFrpfgJnwB4rl77IGmx3wBfg0ADE/+94awCiOzcA0d0agPgMgAGmXnfpA9bgMwAGmHrdpQ9Yg88AGGDqdZc+YA0+A2CAqddd+oA1+AyAAaZed+kD1uAzAAaYet2lD1iDzwAYYOp1lz5gDT4DYICp1136gDX4DIABpl536QPW4DMABph63aUPWIPPAEweYEl7wCnwY4CLnzLAf7vto6jpy582AO3D2OnLnzoA7WsJDBB0HL78m9kD0L6iJhXgMwsYPcB++9D00pf/+DvfL3HA0QPQvq7sfKEQt+0vf5HLX0uATTNAmAHCDBBmgDADhBkgzABhBggzQJgBwgwQZoAwA4QZIMwAYTfPXP7v9JubwXOPMLlIv7kZfHjiIT537TUt4Ai4Bv62XbefaWGPD3HzQW6SJEmSJEmswj8mqknYR8CyngAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flag-icon.0e91b259ebec3fff206281740fa551f3.svg";
export { ForwardRef as ReactComponent };